import React, { useEffect } from "react";
import "./ClimbingWall.css";
import trampoline from "../../../assets/img/imagefile/imagefile/Climbing Wall.png";
import playground from "../../../assets/img/product_img/adult climbing.jpg";
import trampoline1 from "../../../assets/img/product_img/climbing kids.jpg";
import interactiveGame from "../../../assets/img/product_img/climbing tower.jpg";
import { Link } from "react-router-dom";
import Dashboard from "../../../components/Dashboard";
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import Breadcrumb from "../../../Breadcrumb";
import { Helmet } from "react-helmet-async";
import WhatsappButton from "../../../components/WhatsappButton";

const Climbingwall = () => {
  let description = (
    <>
      Your gateway to the ultimate entertainment experience!Explore
      <br />
      our cutting-edge productsand immerse yourself in a world of
      <br />
      innovation and excitement.
    </>
  );
  return (
    <div>
      <Helmet>
              <meta name="trampoline company" content="Discover GEM, the highest quality trampoline for playgrounds, 
offering durability, safety, and endless fun for kids of all ages. 
Perfect for outdoor play!" />
            </Helmet>
      <Header />
      <Dashboard
     Breadcrumb={
   <div style={{ backgroundColor: '', marginTop: '13%',marginLeft:"2%", borderRadius: '5px',width:"100%" }}>
     <Breadcrumb />
  </div>
}

        title={"Climbing Wall"}
        imageUrl={trampoline}
        description={description}
      />

        <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
      <div className="product-container">
        <div className="product-row">
          <div className="product">
            <Link
              to="/Climbingwall/KidsClimbingWall"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={trampoline1}
                alt="indoor commercial playground"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p>Kids Climbing Wall</p>
            </Link>
          </div>
          <div className="product">
            <Link
              to="/Climbingwall/AdultClimbingWall"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={playground}
                alt="playground equipment manufacturers"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p>Adults Climbing Wall</p>
            </Link>
          </div>
          <div className="product">
            <Link
              to="/Climbingwall/SpiderTower"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={interactiveGame}
                alt="trampoline park with soft play"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p> Spider Tower</p>
            </Link>
          </div>
        </div>
      </div>
      {/* Include Footer component */}
      <Footer />
    </div>
  );
};

export default Climbingwall;
